export default __webpack_public_path__ + "static/HU_Con_112_PCG1024_23-ad561d382c194e49caa5350814806dc1.jpg";